module.exports = __webpack_public_path__ + "img/icon-ufo-w.bddd81b4.svg";